import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import * as _ from 'lodash';
import * as moment from "moment";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import firebase from "firebase/app";
import {
  AngularFirestore
} from "angularfire2/firestore";

@IonicPage()
@Component({
  selector: "page-prescriptions",
  templateUrl: "prescriptions.html"
})
export class PrescriptionsPage {

  public preList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  status: string = 'Queued';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private iab: InAppBrowser,
    private afs: AngularFirestore
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.getPrescriptions(this.status);
    });
  }

  ionViewDidLoad() {}

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  openPrescriptionImage(imageUrl)  {
    let browser = this.iab.create(imageUrl, '_blank', {
      closebuttoncaption: "Exit",
      enableViewportScale: "yes"
    });
  }

  public getPrescriptions(status) {
    this.preList = this.afs.collection(`clinics/${this.clinic_id}/prescriptions`, ref => {
      //console.log(status)
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if (status) { query = query.where('status', '==', status) };
      return query.orderBy("createdAt", "desc");
    })
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

  segmentChanged(ev)  {
    //console.log(ev.value);
    this.getPrescriptions(this.status);
    //this.statusFilter$.next("Completed");
  }

}



// WEBPACK FOOTER //
// ./src/pages/prescriptions/prescriptions.ts